<template>
  <div class="personal-data-component">
    <div class="personal-data">
      <ProfileNavbar></ProfileNavbar>
      <div class="data-wrap">

        <div class="status">
          <img v-if="form.status == 0" src="@/assets/images/auth0.png" alt="" />
          <img v-if="form.status == 1" src="@/assets/images/auth1.png" alt="" />
          <img v-if="form.status == 2" src="@/assets/images/auth2.png" alt="" />
        </div>

        <div class="base-info-wrap">

          <el-alert v-if="form.status == 2" :title="form.status_name" type="error" :description="form.reason"
            :closable="false">
          </el-alert>

          <div class="user-type-wrap mgt20">
            <div :class="[{ active: item.id == form.type }, 'item']" v-for="(item, index) in userType" :key="index"
              @click="changeUserType(item.id)">
              {{ item.name }}
            </div>
          </div>
          <el-form autoComplete="on" :model="form" v-loading="loading" :rules="formRules" element-loading-text="给我一点时间"
            label-position="right" ref="form" label-width="0" label-suffix="：">
            <div class="form-wrap my-form">


              <div class="form-item">
                <label>姓名</label>
                <el-form-item prop="name">
                  <el-input type="text" style="width: 250px" v-model="form.name" placeholder="请输入您的姓名">
                  </el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>{{ form.type == 2 ? "企业" : "" }}所在地区</label>
                <el-form-item prop="areaArr">
                  <el-cascader style="width: 350px" v-model="form.areaArr" placeholder="请选择所在地区" clearable
                    :props="cascaderProp" :options="areaList">
                  </el-cascader>
                </el-form-item>
              </div>
              <template v-if="form.type == 0">
                <div class="form-item">
                  <label>学校</label>
                  <el-form-item prop="school">
                    <el-input type="text" style="width: 250px" v-model="form.school" placeholder="请输入学校">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <label>所在院系</label>
                  <el-form-item prop="department">
                    <el-input type="text" style="width: 250px" v-model="form.department" placeholder="请输入所在院系">
                    </el-input>
                  </el-form-item>
                </div>
              </template>
              <template v-if="form.type == 1">
                <div class="form-item">
                  <label>科研院所</label>
                  <el-form-item prop="research_place">
                    <el-input type="text" style="width: 250px" v-model="form.research_place" placeholder="请输入科研院所">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <label>从事方向</label>
                  <el-form-item prop="research_direction">
                    <el-input type="text" style="width: 250px" v-model="form.research_direction" placeholder="请输入从事方向">
                    </el-input>
                  </el-form-item>
                </div>
              </template>
              <template v-if="form.type != 2">
                <div class="form-item">
                  <label>导师</label>
                  <el-form-item prop="mentor">
                    <el-input type="text" style="width: 250px" v-model="form.mentor" placeholder="请输入您的导师">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <label>身份</label>
                  <el-form-item prop="user_type">
                    <el-select v-model="form.user_type" placeholder="请选择身份">
                      <el-option label="老师" :value="0"> </el-option>
                      <el-option label="在读博士" :value="1"> </el-option>
                      <el-option label="在读硕士" :value="2"> </el-option>
                      <el-option label="在读本科" :value="3"> </el-option>
                      <el-option label="专科" :value="4"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>

              <template v-if="form.type == 2">
                <div class="form-item">
                  <label>企业名称</label>
                  <el-form-item prop="company_name">
                    <el-input type="text" style="width: 250px" v-model="form.company_name" placeholder="请输入企业名称">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <label>工作地址</label>
                  <el-form-item prop="company_address">
                    <el-input type="text" style="width: 250px" v-model="form.company_address" placeholder="请输入工作地址">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="form-item">
                  <label>企业税号</label>
                  <el-form-item prop="company_tax_no">
                    <el-input type="text" style="width: 250px" v-model="form.company_tax_no" placeholder="请输入企业税号">
                    </el-input>
                  </el-form-item>
                </div>
              </template>

              <div class="form-item">
                <label>证件</label>
                <el-form-item prop="certificate_type">
                  <el-select v-model="form.certificate_type" placeholder="请选择证件">
                    <el-option label="学生证" :value="0"> </el-option>
                    <el-option label="学位证" :value="1"> </el-option>
                    <el-option label="工作证" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>QQ</label>
                <el-form-item prop="qq">
                  <el-input type="text" style="width: 250px" v-model="form.qq" placeholder="请输入QQ号码（选填）">
                  </el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>邮箱</label>
                <el-form-item prop="email">
                  <el-input type="text" style="width: 250px" v-model="form.email" placeholder="请输入邮箱（选填）">
                  </el-input>
                </el-form-item>
              </div>
              <div class="form-item">
                <label>上传证件</label>
                <div style="display: flex; align-items: center; column-gap: 10px">
                  <div class="my-img-upload">
                    <form-image v-model="form.certificate_front" :config="{ name: '请上传证件正面' }"></form-image>
                  </div>
                  <div class="my-img-upload mgl20">
                    <form-image v-model="form.certificate_back" :config="{ name: '请上传证件背面' }"></form-image>
                  </div>
                </div>
              </div>
              <el-button type="submit" :disabled="disabled" class="my-btn" style="display: block; margin: 20px auto 0"
                @click="handleSubmit">
                提交认证
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIdentityPreview } from "@/api/user";
import { userIdentity } from "@/api/user";
import { getAreaTree } from '@/api/common'
import ProfileNavbar from "@/components/profileNavbar";
import FormImage from '@/components/form/image' //单图上传
export default {
  name: "UserProfile",
  components: {
    ProfileNavbar,
    FormImage
  },
  data() {
    return {
      loading: false,
      activeUserType: 0,
      disabled: false,
      form: {
        type: 0,
        name: "",
        areaArr: [],
        school: "",
        department: "",
        research_place: "",
        research_direction: "",
        company_name: "",
        company_address: "",
        company_tax_no: "",
        certificate_type: 0,
        certificate_front: "",
        certificate_back: "",
        qq: "",
        email: "",
        user_type: 0,
        mentor: "",
        status: 100,
      },
      formRules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        areaArr: [
          { required: true, message: "请选择地址", trigger: "blur" },
        ],
        school: [
          { required: true, message: "请输入学校", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入院系", trigger: "blur" },
        ],
        research_place: [
          { required: true, message: "请输入研究机构", trigger: "blur" },
        ],
        research_direction: [
          { required: true, message: "请输入研究方向", trigger: "blur" },
        ],
        company_name: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        company_address: [],
        company_tax_no: [
          { required: true, message: "请输入企业税号", trigger: "blur" },
        ],
        certificate_type: [
          { required: true, message: "请选择证件", trigger: "blur" },
        ],
        certificate_front: [
          { required: true, message: "请上传证件正面", trigger: "blur" },
        ],
        certificate_back: [
          { required: true, message: "请上传证件背面", trigger: "blur" },
        ],
      },
      userType: [
        {
          name: "高校用户",
          id: 0,
        },
        {
          name: "科研院所",
          id: 1,
        },
        {
          name: "企业开发部门",
          id: 2,
        },
      ],
      areaList: [],
      cascaderProp: {
        value: "id",
        label: "name",
        children: "_child",
        disabled: "disabled",
      },
    };
  },
  computed: {},
  created() {
    this.getIdentityPreview();
    this.getAreaTree();
  },
  methods: {
    getIdentityPreview() {
      this.loading = true;
      getIdentityPreview({})
        .then((res) => {
          this.loading = false;
          if (res.data) {
            this.form = {
              type: res.data.type,
              name: res.data.name,
              areaArr: [res.data.province_id, res.data.city_id, res.data.district_id],
              school: res.data.school,
              department: res.data.department,
              research_place: res.data.research_place,
              research_direction: res.data.research_direction,
              company_name: res.data.company_name,
              company_address: res.data.company_address,
              company_tax_no: res.data.company_tax_no,
              certificate_type: res.data.certificate_type,
              certificate_front: res.data.certificate_front,
              certificate_back: res.data.certificate_back,
              qq: res.data.qq,
              email: res.data.email,
              user_type: res.data.user_type,
              mentor: res.data.mentor,
              status: res.data.status,
              reason: res.data.reason,
              status_name: res.data.status_name,
            };
            if (res.data.status == 2) {
              this.disabled = false;
            } else {
              this.disabled = true;
            }
          }
        })
        .catch((err) => { });
    },
    // 获取所有地区
    getAreaTree() {
      getAreaTree({}).then(response => {
        this.areaList = response.data
      }).catch(() => {

      })
    },
    changeUserType(id) {
      this.form.type = id;
    },
    // 提交信息
    handleSubmit() {
      // 验证form表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _form = JSON.parse(JSON.stringify(this.form))
          _form.province_id = _form.areaArr ? _form.areaArr[0] : 0;
          _form.city_id = _form.areaArr ? _form.areaArr[1] : 0;
          _form.district_id = _form.areaArr ? _form.areaArr[2] : 0;
          userIdentity(_form).then((response) => {
            this.loading = false;
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.getIdentityPreview();
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/profile.less";

.data-wrap {
  align-items: center;
  position: relative;

  .status {
    position: absolute;
    right: 50px;
    top: 250px;
  }
}
</style>
